"use strict";

angular.module("availabilityStatus")
.filter("availabilityStatusName", function(AvailabilityStatus) {
    function filter(model) {
        return AvailabilityStatus.getName(model);
    }
    filter.$stateful = true;
    return filter;
}).filter("availabilityStatusClass", function(AvailabilityStatus) {
    function filter(model) {
        return AvailabilityStatus.getClass(model);
    }
    filter.$stateful = true;
    return filter;
})
.service("AvailabilityStatus", function(gettextCatalog, moment) {
    this.getName = function(model) {
        if (this.isDisabled(model))
            return gettextCatalog.getString("Disabled");
        if (this.isRejected(model))
            return gettextCatalog.getString("Rejected");
        if (this.isRequested(model))
            return gettextCatalog.getString("Requested");
        if (this.isProspect(model))
            return gettextCatalog.getString("Prospect");
        if (this.isInvited(model))
            return gettextCatalog.getString("Invited");
        if (this.isValid(model))
            return gettextCatalog.getString("Valid");
        if (this.HasOrdered(model))
            return gettextCatalog.getString("Has Ordered");
        if (this.isEnabled(model))
            return gettextCatalog.getString("Enabled");
        if (this.isPending(model))
            return gettextCatalog.getString("Pending");
        if (this.isExpired(model))
            return gettextCatalog.getString("Expired");
    };

    this.getClass = function(model) {
        if (this.isDisabled(model))
            return "disabled";
        if (this.isRejected(model))
            return "rejected";
        if (this.isRequested(model))
            return "requested";
        if (this.isProspect(model))
            return "prospect";
        if (this.isInvited(model))
            return "invited";
        if (this.isValid(model))
            return "valid";
        if (this.HasOrdered(model))
            return "has_ordered";
        if (this.isEnabled(model))
            return "enabled";
        if (this.isPending(model))
            return "pending";
        if (this.isExpired(model))
            return "expired";
    };

    this.isRejected = function(model) {
        if (!model.status)
            return false;
        return model.status === "rejected";
    };

    this.isRequested = function(model) {
        if (!model.status)
            return false;
        return model.status === "requested";
    };

    this.isProspect = function(model) {
        if (!model.status)
            return false;
        return model.status === "prospect";
    };

    this.isInvited = function(model) {
        if (!model.status)
            return false;
        return model.status === "invited";
    };

    this.isValid = function(model) {
        if (!model.status)
            return false;
        return model.status === "valid";
    };

    this.HasOrdered = function(model) {
        if (!model.status)
            return false;
        return model.status === "has_ordered";
    };

    this.isEnabled = function(model) {
        return model.enabled && !this.isExpired(model) && !this.isPending(model);
    };
    this.isDisabled = function(model) {
        return !model.enabled;
    };

    this.isExpired = function(model) {
        if (!model.end_date)
            return false;
        return model.enabled && moment().isAfter(model.end_date);
    };

    this.isPending = function(model) {
        if (!model.start_date)
            return false;
        return model.enabled && moment().isBefore(model.start_date);
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/availability-status/availability-status.filter.js
// module id = 676
// module chunks = 0